import { createElement } from 'react';
import { DatePicker2 } from '@alifd/next';
import './index.scss';
const OadpDatePicker2 = function OadpDatePicker2({ name, format, defaultValue, label, placeholder, size, mode, hasBorder, hasClear, showTime, disabled, ...otherProps }) {
    return (createElement(DatePicker2, Object.assign({ name: name, format: format, defaultValue: defaultValue, label: label, hasBorder: hasBorder, size: size, mode: mode, hasClear: hasClear, showTime: showTime, disabled: disabled }, otherProps)));
};
export default OadpDatePicker2;
